<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Matières premières",
          icon: "bi bi-box-seam",
          route: "raw-materials-index",
        },
        {
          label: "Nouvelle commande MP",
          icon: "bi bi-plus-circle-fill",
          route: "raw-materials-create",
        },
        {
          label: "Ajouter articles",
          icon: "bi bi-list-check",
          route: "raw-materials-items-create",
        },
      ],
    };
  },
};
</script>
